export default {
  hero: {
    eyebrow: "The Basetao Spreadsheet Resource Hub",
    h1: "Basetao Spreadsheet: Find Products, Compare Sellers & Shop Smarter",
    desc: "Explore organized Basetao Spreadsheet resources, product finds, seller guides, QC information, shipping guides, reviews and practical buying advice — all in one fast, searchable hub.",
    secondary: "Looking for products, checking a seller, comparing shipping options or researching whether Basetao is legit? Start here.",
    trust: "Independent Resource · Updated Regularly · Safety Focused · Multilingual",
  },
  popular: {
    title: "Popular Topics",
  },
  value: {
    h2: "Everything You Need to Understand Basetao",
    sub: "A clear, honest starting point for product research, seller checks and safer buying.",
    card1: {
      title: "Spreadsheet Resources",
      desc: "Organized product and category resources to help you browse finds faster.",
    },
    card2: {
      title: "Seller Research",
      desc: "Learn how to compare sellers and evaluate product information before ordering.",
    },
    card3: {
      title: "QC Guides",
      desc: "Understand QC photos and what to check before your items are shipped.",
    },
    card4: {
      title: "Shipping Guides",
      desc: "Grasp weight, volumetric weight, shipping lines and insurance basics.",
    },
    card5: {
      title: "Independent Reviews",
      desc: "Balanced write-ups covering experience, fees, warehouse and risks.",
    },
    card6: {
      title: "Safety First",
      desc: "Spot fake links, misleading discounts and risky payment requests.",
    },
  },
  about: {
    h2: "What Is Basetao Spreadsheet?",
    p1: "Basetao Spreadsheet refers to the shared, organized resources people use to discover products, compare sellers and keep track of items before placing an order. It turns scattered product links into a clearer shopping plan.",
    p2: "Because product data and seller details can change quickly, we focus on explaining how these resources work and what to verify — rather than presenting fixed prices or guarantees.",
  },
  review: {
    h2: "Is Basetao Legit? Read the Evidence Before You Buy",
    copy: "Our review content separates facts, user feedback and editorial analysis so you can make your own decision.",
    cta: "Read the Basetao Legit Guide",
  },
  shipping: {
    h2: "Basetao Shipping Cost: What Actually Affects the Price?",
    copy: "Shipping costs can depend on destination, parcel weight, volumetric weight, shipping line, package dimensions, insurance and other factors.",
    cta: "Learn About Shipping Costs",
  },
  safety: {
    h2: "Shop Smarter. Verify Before You Pay.",
    item1: "Verify URLs before clicking",
    item2: "Never share your passwords",
    item3: "Check sellers carefully",
    item4: "Check product evidence",
    item5: "Verify coupons",
    item6: "Understand shipping terms",
    cta: "Open the Safety Checklist",
  },
  articleSection: {
    h2: "Start With Our In-Depth Guide",
    copy: "Curious whether Basetao is legitimate and how to stay safe? Read our full, independently written article.",
    cta: "Read the Full Article",
  },
  guides: {
    h2: "In-Depth Basetao Guides",
    sub: "Ten original, independently written guides covering products, sellers, QC, shipping, warehouse, coupons, safety and comparisons.",
  },
  cta: {
    h2: "Ready to Explore Basetao Spreadsheet Resources?",
    copy: "Start with the main guide, then explore products, sellers, QC, shipping, reviews and safety resources.",
    primary: "Basetao Spreadsheet",
    secondary: "Buy It Now",
  },
};